import React, { useEffect, useRef, useState } from "react";
import { FileText, Copy, AudioLines, Loader, CircleStop, CircleDot, RotateCw, BriefcaseMedical, Pencil, Save, X } from "lucide-react";
import { can_visit, copyToHtmlClipboard, exchangeDate, getDateString, getSecureData, isMobileDevice, notify, setSecureData, usDate, userAccessToken } from "../../helpers";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { Drawer } from "vaul";
import { Config } from "../../Config";
import { speech_phrases } from "../../helpers/constants";
import Lottie from "lottie-react";
import animationData from '../../loader.json';
import { fetchSingleClinicalData, MarkCompleteClinicalNote, resetClinicalNote, saveClinicalTranscriptionText, updateClinicalPostVisitNote } from "../../services/clinicalNotes";
import ClinicalNoteEditPostVisit from "./ClinicalNoteEditPostVisit";
const maleAvatar = "./images/avatar.png";
const femaleAvatar = "./images/female.png";
const otherAvatar = "./images/other.png";

export default function ClinicalNoteViewModal(props) {
  const {
    account_id,
    location_id,
    clinical_id = null,
    active_modal = false,
    set_active_modal = () => {},
    previousScrollPosition = 0,
    setClinicalNoteCheckIds = () => {},
    clinicalNoteCompletedIds = [],
    setClinicalNoteCompletedIds = () => {},
    setClinicalNotePendingIds = () => {}
  } = props;
  let dateStr = getDateString();

  const dropdownRef = useRef(null);
  const [visitActive, setVisitActive] = useState("transcript");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [clinicalData, setClinicalData] = useState({});
  const [transcription, setTranscription] = useState("");
  const [isRecognizing, setIsRecognizing] = useState(false);
  const mediaStreamRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const canvasRef = useRef(null);
  const recognizerRef = useRef(null);
  const dataArrayRef = useRef([]);
  const microphoneRef = useRef(null);
  const scriptProcessorRef = useRef(null);
  const [startTime, setStartTime] = useState(null);
  const [recordTime, setRecordTime] = useState(0);
  const speechTokenRef = useRef(null);
  const translateTokenRef = useRef(null);
  const transcriptionRef = useRef("");
  const previsitRecordTimesRef = useRef({});
  const [postVisitData, setPostVisitData] = useState({});
  const [postvisitLoader, setPostvisitLoader] = useState(false);
  const timerRef = useRef(null);
  const [chechStartConversation, setChechStartConversation] = useState(false);
  const [disabledCallBtn, setDisabledCallBtn] = useState(true);
  const mediaAudioRecorderRef = useRef(null);
  const mediaAudioChunksRef = useRef([]);
  const [startingConversation, setStartingConversation] = useState(false);
  const [stopConversation, setStopConversation] = useState(false);
  const [resetChartLoader, setResetChartLoader] = useState(false);
  const [loadResetData, setLoadResetData] = useState(false);
  const [noteEditMode, setNoteEditMode] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const noteRef = useRef();
  const [markCompleted, setMarkCompleted] = useState(() => {
    return clinicalData?.status === "completed" || clinicalNoteCompletedIds.includes(clinicalData?.id);
  });

  useEffect(() => {
    setMarkCompleted(clinicalData?.status === "completed" || clinicalNoteCompletedIds.includes(clinicalData?.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicalData?.id]);
  
  useEffect(() => {
    fetchTokens();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active_modal]);

  useEffect(() => {
    fetchClinicalData(account_id, location_id, clinical_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, location_id, clinical_id]);

  const fetchClinicalData = async (accountId, locationId, clinicalId) => {
    try {
      const response = await fetchSingleClinicalData(accountId, locationId, clinicalId);
  
      if (response) {
        if (response.data === null) {
          set_active_modal(!active_modal);
          window.scrollTo(0, previousScrollPosition);
        } else {
          setClinicalData(response?.data);
          setPostVisitData(response?.data?.post_visit_data);
          previsitRecordTimesRef.current = response?.data?.record_times || {};
          setTranscription(response?.data?.voice_transcribe || "");
          transcriptionRef.current = response?.data?.voice_transcribe || "";
        }
      }
    } catch (error) {
      
    } finally {
      setIsDataLoaded(true);
    }
  };

  const fetchTokens = async (force=false) => {
    try {
      let getSpeechToken = "";
      let getTranslateToken = "";
      let timeChecker = false;
      if(force === false) {
        getSpeechToken = await getSecureData("speech_token");
        getTranslateToken = await getSecureData("translate_token");
        timeChecker = checkRecorderToken(getSpeechToken);
      }
      
      if(getSpeechToken || getSpeechToken === null || getSpeechToken.trim() === "") {
        if(timeChecker === false) {
          const response = await fetch(`${Config.apiServerUrl}/transcribe/token`, {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${userAccessToken() || ""}`,
            },
          });
    
          const data = await response.json();
    
          if (data?.status === "success") {
            speechTokenRef.current = data?.speech_token;
            translateTokenRef.current = data?.translate_token;

            await setSecureData("speech_token", data?.speech_token)
            await setSecureData("translate_token", data?.translate_token)
          } else {
            console.error("Error fetching token:", data?.message);
          }
        } else {
          speechTokenRef.current = getSpeechToken;
          translateTokenRef.current = getTranslateToken;
        }
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
    } finally {
      setDisabledCallBtn(false);
    }
  };

  const checkRecorderToken = (token) => {
    let exp;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      exp = payload?.exp;
      if (!exp) {
        return false;
      } else {
        const currentTime = Math.floor(Date.now() / 1000);
        if (exp - currentTime < 180) {
          return true;
        }
      }
    } catch (error) {
      return false;
    }
  };

  const translateToEnglish = async (text, fromLanguage) => {
    if (!translateTokenRef.current) {
      console.log("No translate token available.");
      return text;
    }

    try {
      const endpoint = "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0";
      const response = await fetch(`${endpoint}&from=${fromLanguage}&to=en`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${translateTokenRef.current}`,
        },
        body: JSON.stringify([{ text }]),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Token expired, refresh it
          await fetchTokens(true);
          // Retry the translation with new token
          const retryResponse = await fetch(`${endpoint}&from=${fromLanguage}&to=en`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${translateTokenRef.current}`,
            },
            body: JSON.stringify([{ text }]),
          });
          if (!retryResponse.ok) {
            throw new Error("Translation request failed after token refresh");
          }
          const translations = await retryResponse.json();
          return translations[0]?.translations[0]?.text;
        }
        throw new Error("Translation request failed");
      }

      const translations = await response.json();
      return translations[0]?.translations[0]?.text;
    } catch (error) {
      console.error("Translation error:", error);
      return text;
    }
  };

  const toggleRecognition = async () => {
    if (!speechTokenRef.current) {
      console.error("No valid token available.");
      return;
    }

    if (!isRecognizing) {
      setStartingConversation(true);
      // Start recognition with auto language detection
      const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
        speechTokenRef.current,
        "eastus"
      );

      // Set higher quality settings for speech recognition
      speechConfig.setProperty(
        SpeechSDK.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
        "600000" // 10 minutes timeout
      );
      speechConfig.setProperty(
        SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
        "10000" // 10 seconds end silence timeout
      );
      speechConfig.setProperty(
        SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode,
        "Continuous"
      );

      // Create AutoDetectSourceLanguageConfig with the desired languages
      const autoDetectSourceLanguageConfig =
        SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([
          "en-US",
          "es-ES",
          "es-CO",
          "he-IL",
          "ru-RU",
          "bn-IN"
        ]);

      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      recognizerRef.current = SpeechSDK.SpeechRecognizer.FromConfig(
        speechConfig, autoDetectSourceLanguageConfig, audioConfig
      );
      const phraseListGrammar = SpeechSDK.PhraseListGrammar.fromRecognizer(recognizerRef.current);
      speech_phrases.forEach((phrase) => phraseListGrammar.addPhrase(phrase));

      setChechStartConversation(true);
      setRecordTime(0); // reset timer
      timerRef.current = setInterval(() => {
        setRecordTime((prev) => prev + 1);
        // Check token expiration every 30 seconds
        if (recordTime % 30 === 0) {
          const callTimeChecker = checkRecorderToken(speechTokenRef.current);
          if(callTimeChecker === false) {
            fetchTokens(true);
          }
        }
      }, 1000);
      setVisitActive("transcript");

      // ---- START: AUDIO RECORDING START ----
      try {
        const streamAudio = await navigator.mediaDevices.getUserMedia({ 
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
            sampleRate: 48000,
            channelCount: 1
          } 
        });
        // Store the stream if needed for later clean-up
        window._rawAudioStream = streamAudio;

        const streamMediaRecorder = new MediaRecorder(streamAudio, {
          mimeType: 'audio/webm;codecs=opus',
          audioBitsPerSecond: 128000
        });
        mediaAudioRecorderRef.current = streamMediaRecorder;
        mediaAudioChunksRef.current = [];

        streamMediaRecorder.ondataavailable = (e) => {
          mediaAudioChunksRef.current.push(e.data);
        };

        // Request data every 5 seconds to prevent memory issues
        streamMediaRecorder.start(5000);
      } catch (err) {
        console.error("Could not start raw audio recording:", err);
        notify("Error", "Failed to start audio recording. Please check your microphone settings.");
      }
      // ---- END: AUDIO RECORDING START ----

      recognizerRef.current.recognized = async (s, e) => {
        if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
          const languageDetectionResult = SpeechSDK.AutoDetectSourceLanguageResult.fromResult(e.result);
          const detectedLanguage = languageDetectionResult.language;

          let finalText = e.result.text;
          if (detectedLanguage !== "en-US") {
            finalText = await translateToEnglish(finalText, detectedLanguage);
          }
          
          // Check token expiration during recognition
          const callTimeChecker = checkRecorderToken(speechTokenRef.current);
          if(callTimeChecker === false) {
            await fetchTokens(true);
          }

          setTranscription((prev) => prev + `${finalText}\n`);
          transcriptionRef.current = transcriptionRef.current + `${finalText}\n`;
          setSecureData("ideal_using_mic_time", Math.floor(Date.now() / 1000))
        }
      };

      recognizerRef.current.canceled = (s, e) => {
        if (e.reason === SpeechSDK.CancellationReason.Error) {
          console.error("Recognition error:", e.errorDetails);
          // Attempt to restart recognition if it was an error
          if (isRecognizing) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
              setTimeout(() => {
                if (speechTokenRef.current) {
                  toggleRecognition();
                }
              }, 1000);
            });
          }
        } else {
          recognizerRef.current.stopContinuousRecognitionAsync();
          setIsRecognizing(false);
        }
      };

      recognizerRef.current.startContinuousRecognitionAsync(() => {
        setStartTime(Date.now()); // Start timer
        setIsRecognizing(true);
        setStartingConversation(false);

        // setShowProcessingAnimation(true);
        // Initialize Audio Context and Analyser
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
        .then((stream) => {
          mediaStreamRef.current = stream;
          audioContextRef.current = new AudioContext();
          analyserRef.current = audioContextRef.current.createAnalyser();
          analyserRef.current.fftSize = 256;
          microphoneRef.current = audioContextRef.current.createMediaStreamSource(stream);
          scriptProcessorRef.current = audioContextRef.current.createScriptProcessor(256, 1, 1);

          analyserRef.current.connect(scriptProcessorRef.current);
          scriptProcessorRef.current.connect(audioContextRef.current.destination);
          microphoneRef.current.connect(analyserRef.current);

          dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);

          drawWaveform();
        })
        .catch((error) => {
          notify("Error", "Failed to access microphone. Please check your device settings.");
        });
      },
      (error) => {
        notify("Error", "Failed to start recognition. Please try again.");
      });
    } else {
      // Stop recognition
      setStartingConversation(false);
      setStopConversation(true);
      setTimeout(async () => {
        if (recognizerRef.current) {
          setStopConversation(false);
          setVisitActive("note");
          setPostvisitLoader(true);

          const endTime = Date.now();
          const elapsedTime = Math.floor((endTime - startTime) / 1000);
          setRecordTime(0);
          clearInterval(timerRef.current);

          const today = dateStr;
          previsitRecordTimesRef.current = { ...previsitRecordTimesRef.current, [today]: [...(previsitRecordTimesRef.current[today] || []), elapsedTime] };

          // ---- START: AUDIO FILE RECORDING STOP ----
          const streamMediaRecorderStatus = mediaAudioRecorderRef.current;
          if (streamMediaRecorderStatus && streamMediaRecorderStatus.state !== 'inactive') {
            streamMediaRecorderStatus.stop();
          }       
          if (window._rawAudioStream) {
            window._rawAudioStream.getTracks().forEach(track => track.stop());
            window._rawAudioStream = null;
          }

          // ---- END: AUDIO FILE RECORDING STOP ----
          await stopRecording();
        }
      }, 2000);
    }
  };

  const stopRecording = async () => {
    if (recognizerRef.current) {
      recognizerRef.current.stopContinuousRecognitionAsync(() => {
        if (mediaStreamRef.current) {
          mediaStreamRef.current.getTracks().forEach((track) => track.stop());
          mediaStreamRef.current = null;
        }

        // Close audio context
        if (audioContextRef.current) {
          audioContextRef.current.close();
          audioContextRef.current = null;
        }

        // Stop and remove analyser
        if (analyserRef.current) {
          analyserRef.current.disconnect();
          analyserRef.current = null;
        }

        // Stop animation
        if (microphoneRef.current) {
          microphoneRef.current.disconnect();
        }
        if (scriptProcessorRef.current) {
          scriptProcessorRef.current.disconnect();
        }

        setIsRecognizing(false);
      },
      (error) => console.error("Error stopping recognition:", error));
    }

    if(chechStartConversation) {
      let fullSentence = transcriptionRef.current;

      // First save the transcription
      const saveResponse = await handleSaveTranscript(
        account_id,
        location_id,
        clinicalData?.id,
        fullSentence
      );

      // Only proceed with post notes if transcription was saved successfully
      if (saveResponse && saveResponse.data && saveResponse.data.status === "success") {
        await getPostVisitFromDiagnosis(clinicalData?.id);
      }
    }
  };

  const drawWaveform = () => {
    if (!canvasRef.current || !analyserRef.current) return;

    const canvas = canvasRef.current;
    const canvasCtx = canvas.getContext("2d");
    if (!canvasCtx) return;

    requestAnimationFrame(drawWaveform);
    analyserRef.current.getByteFrequencyData(dataArrayRef.current);

    canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
    const barCount = 20;
    const barWidth = (canvas.width / (2 * barCount)) * 0.8;
    const barGap = barWidth * 0.5;
    const centerY = canvas.height / 2;
    const centerX = canvas.width / 2;

    for (let i = 0; i < barCount; i++) {
      const index = Math.floor(i * (dataArrayRef.current.length / barCount));
      const barHeight = (dataArrayRef.current[index] / 256) * canvas.height;
      canvasCtx.fillStyle = '#00a106';
      canvasCtx.fillRect(centerX + i * (barWidth + barGap), centerY - barHeight / 2, barWidth, barHeight);
      canvasCtx.fillRect(centerX - (i + 1) * (barWidth + barGap), centerY - barHeight / 2, barWidth, barHeight);
    }
  };

  const handleTranscriptChange = (e) => {
    setTranscription(e.target.value);
  };

  const handleSaveTranscript = async (
    accountId,
    locationId,
    id,
    text
  ) => {
    try {
      const response = await saveClinicalTranscriptionText(
        accountId,
        locationId,
        id,
        text,
        previsitRecordTimesRef.current
      );
      if (response) {
        if (!response?.detail && response?.data?.status === "success") {
          // notify("success", "Transcription saved successfully")
        }
      }
      return response;
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        // notify("error", error?.response?.data?.detail, 0.5);
      }
      throw error;
    }
  };

  const getPostVisitFromDiagnosis = async (clinicalIid) => {
    try {
      const response = await fetch(
        `${Config.apiServerUrl}/clinical-note/post_visit_notes?account_id=${account_id}&location_id=${location_id}&clinical_note_id=${clinicalIid}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response?.json();
      if (data?.status === "success") {
        if (Object.keys(data)?.length > 0) {
          setPostVisitData(data?.post_visit_data || {});
          if((Object.keys(data.post_visit_data || {}).length > 0) && (data.post_visit_data !== null) && (data.post_visit_data !== "")) {
            updateClinicalNoteState(clinicalIid, 'checked');
          } else {
            setClinicalNoteCheckIds((prev) => prev.filter((val) => val !== clinicalIid));
          }
        }
      }
    } catch (error) {
      console.error("Error retrieving post visit from diagnosis:", error);
    } finally {
      setPostvisitLoader(false);
    }
  };
  
  const formatRecordingTime = (totalSeconds) => {
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const secs = String(totalSeconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  const updateClinicalNoteState = (id, targetState) => {
    // Remove ID from all arrays
    setClinicalNotePendingIds((prev) => prev.filter((val) => val !== id));
    setClinicalNoteCompletedIds((prev) => prev.filter((val) => val !== id));
    setClinicalNoteCheckIds((prev) => prev.filter((val) => val !== id));
  
    // Add to the target state
    switch (targetState) {
      case 'pending':
        setClinicalNotePendingIds((prev) => [...new Set([...prev, id])]);
        break;
      case 'completed':
        setClinicalNoteCompletedIds((prev) => [...new Set([...prev, id])]);
        break;
      case 'checked':
        setClinicalNoteCheckIds((prev) => [...new Set([...prev, id])]);
        break;
      default:
        break;
    }
  };  

  const handleResetChart = async(id) => {
    setResetChartLoader(true);
    setLoadResetData(true);
    try {
      const resetPostData = {
        account_id: account_id,
        location_id: location_id,
        id: id
      };
      const response = await resetClinicalNote(resetPostData);
    
      if (response) {
        if (response?.detail) {
          notify('error', response?.detail);
        } else { 
          if(response?.data?.status === 'success'){
            notify("success", response?.data?.message);
            let res_data = response?.data?.result;
            setClinicalData(res_data);
            setTranscription(res_data?.voice_transcribe);
            setMarkCompleted(res_data?.status);
            setPostVisitData(res_data?.post_visit_data);
            if((Object.keys(res_data.post_visit_data || {}).length > 0) && (res_data.post_visit_data !== null) && (res_data.post_visit_data !== "")) {
              updateClinicalNoteState(id, 'checked');
            } else {
              setClinicalNoteCheckIds((prev) => prev.filter((val) => val !== id));
            }
            if(res_data.status === "completed") {
              updateClinicalNoteState(id, 'completed');
            }
            if(res_data.status === "pending") {
              updateClinicalNoteState(id, 'pending');
            }
          } else {
            notify("error", response?.data?.message);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setResetChartLoader(false);
      setLoadResetData(false);
    }
  }

  const handleMarkCompleted = async(isChecked, id) => {
    setMarkCompleted(isChecked);
    try {
      let setStatus = "pending";
      if(isChecked === true) {
        setStatus = "completed"
      }
      const completePostData = {
        account_id: account_id,
        location_id: location_id,
        id: id,
        status: setStatus
      };
      
      const response = await MarkCompleteClinicalNote(completePostData);
    
      if (response) {
        if (response?.detail) {
          notify('error', response?.detail);
        } else { 
          if(response?.data?.status === 'success'){
            let res_data = response?.data?.result;
            if(res_data.status === "completed") {
              updateClinicalNoteState(id, 'completed');
            }
            if(res_data.status === "pending") {
              updateClinicalNoteState(id, 'pending');
            }
          } else {
            notify("error", response?.data?.message);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
    }
  };

  const saveNoteData = async () => {
    const editData = noteRef.current?.getCleanedEditNoteData();
    if (editData) {
      const editNoteData = {
        account_id: account_id,
        location_id: location_id,
        id: clinicalData?.id,
        post_visit_data: editData,
      };

      try {
        const response = await updateClinicalPostVisitNote(editNoteData);
        if(response){
          if(response?.detail) {
            notify("error", response?.detail, 0.5);
          }
          if(response?.data?.status === "success") {
            setPostVisitData(editData)
            notify("success", response?.data?.message, 0.5);
          } else {
            notify("error", response?.data?.message, 0.5);
          }
        }
      } catch (error) {
        if (error?.response && error?.response?.data && error?.response?.data?.detail) {
          notify("error", error?.response?.data?.detail, 0.5);
        }
      } finally {
        setNoteEditMode(false);
        setHasChanges(false);
      }
    }
  }

  const closeViewModal = () => {
    set_active_modal(!active_modal);
    window.scrollTo(0, previousScrollPosition);
  };


  return (
    <>
      <div style={{ height: "100%" }} ref={dropdownRef}>
        <Drawer.Root open={active_modal} onOpenChange={closeViewModal}>
          <Drawer.Trigger className="docpro_single_patiant_modal_btn"></Drawer.Trigger>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay" />
            <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
              <Drawer.Title className="sr-only"> Patient Audit Report Details </Drawer.Title>
              <Drawer.Description className="sr-only"> View details of an parient audit reports </Drawer.Description>
              <div className="docpro_modal_wrap docpro_style_1 docpro_modal_xl">
                <div className="docpro_modal" style={{ padding: 0 }}>
                  {isDataLoaded ? (
                    <div className="docpro_previsit docpro_clinical_note_view">
                      <div className="docpro_patient_head_2">
                        <div className="docpro_media" style={{ alignItems: 'start' }}>
                          <img
                            src={
                              clinicalData && clinicalData.sex === "M"
                              ? maleAvatar
                              : clinicalData && clinicalData.sex === "F"
                              ? femaleAvatar
                              : otherAvatar
                            }
                            alt="Avatar"
                            width={40}
                            height={40}
                            style={{ objectFit: "cover", borderRadius: "50%" }}
                          />
                          <div className="docpro_media_right">
                            <h2 className="docpro_fs_20 docpro_text_uppercase" style={{ marginBottom: 0 }}>
                              {clinicalData && clinicalData.last_name && clinicalData.first_name
                                ? `${clinicalData.last_name} ${clinicalData.first_name}`
                                : ""
                              }
                            </h2>
                            <div className="docpro_patient_head_info_list">
                              <ul style={{ marginTop: 3 }}>
                                <li>
                                  <b>DOS: </b>
                                  {usDate(clinicalData?.dos, false)}
                                </li>
                                <li>
                                  <b>DOB: </b>
                                  {exchangeDate(clinicalData?.dob)}
                                  {isMobileDevice() ? <br /> : <span className="docpro_ternary_color"> | </span>}
                                  <b>Gender: </b>{clinicalData?.gender}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="docpro_patient_head_buttons_wrap">
                          <div className="docpro_patient_head_buttons relative">
                            <button
                              className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn docpro_tip_checkbox${isRecognizing ? " docpro_recording_bg" : ""}`}
                              type="button"
                              style={isMobileDevice() ? { padding: 13 } : { minWidth: '220px' }}
                              onClick={toggleRecognition}
                            >
                              {isRecognizing ? (
                                <>
                                  <CircleStop /> End recording
                                </>
                              ) : (
                                <>
                                  <CircleDot /> Start Conversation
                                  {disabledCallBtn && (
                                    <span className="docpro_loading">
                                      <Loader width={20} height={20} />
                                    </span>
                                  )}
                                </>
                              )}
                            </button>
                            <div className={`docpro_patient_head_buttons_in${isRecognizing ? " set_height" : ""}`}>
                              <div className={`docpro_record_timer ${isRecognizing ? "block" : "none"}`}>
                                <canvas
                                  ref={canvasRef}
                                  width={112}
                                  height={32}
                                ></canvas>
                                <span style={{ width: '65px' }}>
                                  {formatRecordingTime(recordTime)}
                                </span>
                              </div>
                              {!isRecognizing && can_visit("clinical_notes_reset") && (
                                <button
                                  className="docpro_bordered_btn docpro_fw_600 docpro_sp_btn_1 w-full"
                                  type="button"
                                  style={isMobileDevice() ? { padding: 13 } : {}}
                                  onClick={() => (handleResetChart(clinicalData?.id))}
                                >
                                  <RotateCw width={16} height={16} />
                                  <span>Reset Chart</span>
                                  {resetChartLoader && (
                                    <span className="docpro_loading">
                                      <Loader width={20} height={20} />
                                    </span>
                                  )}
                                </button>
                              )}
                              {(!isRecognizing && can_visit("clinical_notes_update") && isMobileDevice()) && (
                                <div className="flex items-center" style={{ minWidth: "145px" }}>
                                  <div className="docpro_checkbox">
                                    <input
                                      type="checkbox"
                                      name="check_all_yes"
                                      checked={markCompleted === true}
                                      onChange={(e) => handleMarkCompleted(e.target.checked, clinicalData?.id)}
                                    />
                                    <label style={{ marginLeft: "8px" }}>Mark as Complete
                                    </label>
                                  </div>
                                </div>
                              )}
                            </div>
                            {startingConversation && (
                              <div className="docpro_call_starting">
                                <span>Starting...</span>
                              </div>
                            )}
                            {stopConversation && (
                              <div className="docpro_call_starting">
                                <span>Processing...</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="docpro_patient_body_2">
                        {!loadResetData ? (
                          <>
                            <div className="docpro_patient_body_2_right clinical_left_note_card">
                              <div className="docpro_modal_card_2">
                                <div className="docpro_tab_wrap">
                                  <div className="docpro_tab">
                                    <p className="chart_inline_copy mb-0" style={{ padding: '10px 10px 8px 13px', gap: 6 }}>
                                      <BriefcaseMedical width={16} height={16} />
                                      <b>DIAGNOSIS CODE:</b>
                                    </p>
                                  </div>
                                  <hr />
                                </div>
                                <div className="docpro_tab_modal_right_in clinical_left_note_view">
                                  <div className="docpro_modal_card_1_body">
                                    {typeof clinicalData?.diagnoses === "string" && clinicalData.diagnoses.trim() !== "" ? (
                                      <ol style={{ margin: 0 }}>
                                        {(clinicalData.diagnoses.match(
                                            /(.+?\([A-Z][0-9][0-9](?:\.[0-9A-Z]+)?\))(?=,|$)/g
                                          ) || []
                                        ).map((entry, i) => {
                                          const trimmed = entry.replace(/^,/, '').trim();
                                          const match = trimmed.match(/^(.*)\(([^()]+)\)$/);
                                          let description = trimmed, code = "";

                                          if (match) {
                                            const potentialCode = match[2].trim();
                                            const icdPattern = /^[A-Z][0-9][0-9](\.[0-9A-Z]+)?$/;
                                            if (icdPattern.test(potentialCode)) {
                                              description = match[1].trim();
                                              code = potentialCode;
                                            }
                                          }

                                          return (
                                            <li key={i}>
                                              {description}{" "}
                                              {code && (
                                                <>
                                                  <b className="mr-2">
                                                    (<span className={`diagnosis_code_copy_${i}`}>{code}</span>)
                                                  </b>
                                                  <span
                                                    className="pointer"
                                                    onClick={() => copyToHtmlClipboard(`diagnosis_code_copy_${i}`)}
                                                  >
                                                    <Copy height={14} width={14} />
                                                  </span>
                                                </>
                                              )}
                                            </li>
                                          );
                                        })}
                                      </ol>
                                    ) : (
                                      <p className="docpro_ternary_color"><i>None</i></p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="docpro_patient_body_2_left clinical_right_note_card">
                              <div className="docpro_modal_card_2 relative">
                                {(!isRecognizing && can_visit("clinical_notes_update") && !isMobileDevice()) && (
                                  <div className="absolute" style={{ minWidth: "145px", top: 9, right: 6 }}>
                                    <div className="docpro_checkbox">
                                      <input
                                        type="checkbox"
                                        name="check_all_yes"
                                        checked={markCompleted === true}
                                        onChange={(e) => handleMarkCompleted(e.target.checked, clinicalData?.id)}
                                      />
                                      <label style={{ marginLeft: "8px" }}>Mark as Complete
                                      </label>
                                    </div>
                                  </div>
                                )}

                                <div className="docpro_tab_wrap">
                                  <div className="docpro_tab">
                                    <button
                                      type="button"
                                      className={`docpro_tab_item ${visitActive === "transcript" ? "active" : ""}`}
                                      onClick={() => setVisitActive("transcript")}
                                    >
                                      <AudioLines width={16} height={16} />
                                      Transcript
                                    </button>
                                    <button
                                      type="button"
                                      className={`docpro_tab_item ${visitActive === "note" ? "active" : ""}`}
                                      onClick={() => setVisitActive("note")}
                                    >
                                      <FileText width={16} height={16} />
                                      Note
                                    </button>
                                  </div>
                                  <hr />
                                </div>
                                {visitActive === "note" && (
                                  <div className="docpro_tab_modal_right" style={{ padding: "0 0 10px 0" }}>
                                    <div className="docpro_tab_modal_right_in docpro_tab_right_bg">
                                      {postvisitLoader ? (
                                        <div className="docpro_loader_animation">
                                          <Lottie
                                            animationData={animationData}
                                            loop={true}
                                          />
                                          <div className="cs_recording_animation_text">
                                            Generating…
                                          </div>
                                        </div>
                                      ) : (
                                        <>
                                          {postVisitData && Object?.keys(postVisitData)?.length > 0 ? (
                                            <>
                                              <div className="docpro_border_btns_wrap note_div">
                                                {!noteEditMode ? (
                                                  <button
                                                    className="docpro_border_btn copy_all_btn"
                                                    onClick={() => {setNoteEditMode(true);}}
                                                  >
                                                    <Pencil width={15} height={15} />
                                                    <span>Edit</span>
                                                  </button>
                                                ) : (
                                                  <>
                                                    {hasChanges && (
                                                      <button
                                                        className="docpro_border_btn docpro_filed_btn copy_all_btn"
                                                        onClick={saveNoteData}
                                                      >
                                                        <Save width={15} height={15} />
                                                        <span>Save</span>
                                                      </button>
                                                    )}
                                                    <button
                                                      className="docpro_border_btn copy_all_btn"
                                                      onClick={() => {setNoteEditMode(false);}}
                                                    >
                                                      <X width={15} height={15} />
                                                      <span>Cancel</span>
                                                    </button>
                                                  </>
                                                )}
                                                <button
                                                  className="docpro_border_btn copy_all_btn"
                                                  onClick={() =>
                                                    copyToHtmlClipboard("subjective_note_copy")
                                                  }
                                                >
                                                  <Copy width={15} height={15} />
                                                  <span>Copy all</span>
                                                </button>
                                              </div>

                                              <div className="docpro_modal_card_1 no_style">
                                                <div className="docpro_modal_card_1_body">
                                                  <div className="docpro_modal_card_1_content subjective_note_copy">
                                                    {noteEditMode ? (
                                                      <ClinicalNoteEditPostVisit 
                                                        ref={noteRef}
                                                        initialData={postVisitData}
                                                        noteEditMode={noteEditMode}
                                                        setHasChanges={setHasChanges}
                                                      />
                                                    ) : (
                                                      <>
                                                        {/* REASON FOR VISIT */}
                                                        <div>
                                                          <p className="chart_inline_copy">
                                                            <b>REASON FOR VISIT:</b>
                                                            <span className="pointer" onClick={() => copyToHtmlClipboard("reason_for_visit_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          {Array.isArray(postVisitData?.reason_for_visit) &&
                                                          postVisitData?.reason_for_visit?.length > 0 &&
                                                          postVisitData?.reason_for_visit?.every(item => typeof item === "string") ? (
                                                            <ul className="reason_for_visit_copy">
                                                              {postVisitData?.reason_for_visit.map((r, i) => (
                                                                <li key={i} className="docpro_capitalize">
                                                                  {r?.replace(/^Chronic disease management:\s*/i, '')}
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          ) : (
                                                            <p className="docpro_ternary_color"><i>None</i></p>
                                                          )}
                                                        </div>
                                                        <br />

                                                        {/* HISTORY OF PRESENT ILLNESS */}
                                                        <div>
                                                          <p className="chart_inline_copy">
                                                            <b>HISTORY OF PRESENT ILLNESS:</b>
                                                            <span className="pointer" onClick={() => copyToHtmlClipboard("present_illness_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          <div className="present_illness_copy">
                                                            {postVisitData?.history_of_present_illness ? (
                                                              typeof postVisitData?.history_of_present_illness === "string" ? (
                                                                <p>{postVisitData?.history_of_present_illness}</p>
                                                              ) : Array?.isArray(postVisitData?.history_of_present_illness) && postVisitData?.history_of_present_illness?.length > 0 ? (
                                                                postVisitData?.history_of_present_illness?.map((item, idx) => (
                                                                  <span key={idx}>{item}<br /></span>
                                                                ))
                                                              ) : (
                                                                <p className="docpro_ternary_color"><i>None</i></p>
                                                              )
                                                            ) : (
                                                              <p className="docpro_ternary_color"><i>None</i></p>
                                                            )}
                                                          </div>
                                                        </div>
                                                        <br />

                                                        {/* VITAL SIGNS */}
                                                        {postVisitData?.vital_signs && Object.keys(postVisitData.vital_signs).length > 0 && (
                                                          <>
                                                            <div>
                                                              <p className="chart_inline_copy">
                                                                <b>VITAL SIGNS:</b>
                                                                <span className="pointer" onClick={() => copyToHtmlClipboard("vital_signs_copy")}>
                                                                  <Copy height={14} width={14} />
                                                                </span>
                                                              </p>
                                                              <ul className="vital_signs_copy docpro_grid docpro_grid_col_3">
                                                                {Object.entries(postVisitData.vital_signs)?.map(
                                                                  ([signName, signValue]) => (
                                                                    <li key={signName} className="docpro_grid_item">
                                                                      <span>{signName}: {signValue}</span>
                                                                    </li>
                                                                  )
                                                                )}
                                                              </ul>
                                                            </div>
                                                            <br />
                                                          </>
                                                        )}

                                                        {/* REVIEW OF SYSTEMS */}
                                                        <div>
                                                          <p className="chart_inline_copy">
                                                            <b>REVIEW OF SYSTEMS:</b>
                                                            <span className="pointer" onClick={() => copyToHtmlClipboard("review_of_systems_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          {Array?.isArray(postVisitData?.review_of_systems) && postVisitData?.review_of_systems?.length > 0 ? (
                                                            <ul className="review_of_systems_copy">
                                                              {postVisitData?.review_of_systems?.map((item, i) => (
                                                                <li key={i}>
                                                                  <span className={`mr-2 review_of_systems_copy_${i}`}>{item}</span>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`review_of_systems_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          ) : (
                                                            <p className="docpro_ternary_color"><i>None</i></p>
                                                          )}
                                                        </div>
                                                        <br />

                                                        {/* PHYSICAL EXAM */}
                                                        <div>
                                                          <p className="chart_inline_copy">
                                                            <b>PHYSICAL EXAM:</b>
                                                            <span className="pointer" onClick={() => copyToHtmlClipboard("physical_exam_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          {Array?.isArray(postVisitData?.physical_exam) && postVisitData?.physical_exam?.length > 0 ? (
                                                            <ul className="physical_exam_copy">
                                                              {postVisitData?.physical_exam?.map((item, i) => (
                                                                <li key={i}>
                                                                  <span className={`mr-2 physical_exam_copy_${i}`}>{item}</span>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`physical_exam_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          ) : (
                                                            <p className="docpro_ternary_color"><i>None</i></p>
                                                          )}
                                                        </div>
                                                        <br />

                                                        {/* DIAGNOSIS CODE */}
                                                        <div>
                                                          <p className="chart_inline_copy">
                                                            <b>DIAGNOSIS CODE:</b>
                                                          </p>
                                                          {Array?.isArray(postVisitData?.icd_codes) && postVisitData?.icd_codes?.length > 0 ? (
                                                            <ol style={{ margin: 0, marginLeft: '6px' }}>
                                                              {postVisitData?.icd_codes.map((code, i) => (
                                                                <li key={i}>
                                                                  {code?.description} <b className="mr-2">(<span className={`diagnosis_code_copy_${i}`}>{code?.code}</span>)</b>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`diagnosis_code_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                </li>
                                                              ))}
                                                            </ol>
                                                          ) : (
                                                            <p className="docpro_ternary_color"><i>None</i></p>
                                                          )}
                                                        </div>
                                                        <br />

                                                        {/* ASSESSMENT/PLAN */}
                                                        <div>
                                                          <p className="chart_inline_copy">
                                                            <b>ASSESSMENT/PLAN:</b>
                                                          </p>
                                                          {Array?.isArray(postVisitData?.assessment) && postVisitData?.assessment?.length > 0 ? (
                                                            <ul>
                                                              {postVisitData?.assessment?.map((item, i) => (
                                                                <li key={i}>
                                                                  <b className="mr-2">{item?.icd_code}</b>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                  <br />
                                                                  <span className={`assessment_plan_copy_${i}`}>{item?.assessment_plan}</span>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          ) : (
                                                            <p className="docpro_ternary_color"><i>None</i></p>
                                                          )}
                                                        </div>

                                                        {/* OTHER ASSESSMENT/PLAN */}
                                                        {(Array?.isArray(postVisitData?.other_assessment) && postVisitData?.other_assessment?.length > 0) && (
                                                          <>
                                                            <br />
                                                            <div>
                                                              <p className="chart_inline_copy">
                                                                <b>OTHER ASSESSMENT/PLAN:</b>
                                                                <span className="pointer" onClick={() => copyToHtmlClipboard("other_assessment_plan_copy")}>
                                                                  <Copy height={14} width={14} />
                                                                </span>
                                                              </p>
                                                              <ul className="other_assessment_plan_copy">
                                                                {postVisitData?.other_assessment?.map((item, i) => (
                                                                  <li key={i}>
                                                                    <span>{item?.other_assessment_plan}</span>
                                                                  </li>
                                                                ))}
                                                              </ul>
                                                            </div>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="docpro_modal_card_1 no_style">
                                              <div className="docpro_modal_card_1_body">
                                                <div className="docpro_modal_card_1_content subjective_note_copy">
                                                  <p className="docpro_ternary_color">Note not available</p>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {visitActive === "transcript" && (
                                  <div className="docpro_modal_card_1_wrap_overflow">
                                    <div style={{ padding: '15px 7px 0' }} >
                                      <textarea
                                        rows={20}
                                        cols={28}
                                        id="transcription_output"
                                        value={transcription}
                                        onChange={handleTranscriptChange}
                                        placeholder="Write what happened in the visit — symptoms, medications, exam findings, and next steps..."
                                        readOnly
                                        style={{
                                          width: "100%",
                                          height: "97%",
                                          padding: 0,
                                          border: "none",
                                          outline: "none",
                                          resize: "none",
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div
                            className="loading"
                            style={{
                              width: "100%",
                              height: "calc(100vh - 158px)",
                              justifyContent: "center",
                              display: "grid",
                              alignContent: "center",
                            }}
                          >
                            <span className="audit_report_loader"></span>
                            <p style={{ margin: "10px" }}>Loading...</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div
                      className="loading"
                      style={{
                        width: "100%",
                        height: "80vh",
                        justifyContent: "center",
                        display: "grid",
                        alignContent: "center",
                      }}
                    >
                      <span className="audit_report_loader"></span>
                      <p style={{ margin: "10px" }}>Loading...</p>
                    </div>
                  )}
                </div>
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>
    </>
  );
}
